export const WEATHER = {
  'Sun': {
    boost: ['Fire'],
    reduce: ['Water'],
    icon: '☀️',
    description: 'Boosts Fire moves, weakens Water moves'
  },
  'Rain': {
    boost: ['Water'],
    reduce: ['Fire'],
    icon: '🌧️',
    description: 'Boosts Water moves, weakens Fire moves'
  },
  'Sand': {
    boost: ['Rock'],
    icon: '🏜️',
    description: 'Boosts Rock-type Special Defense'
  },
  'Snow': {
    boost: ['Ice'],
    icon: '❄️',
    description: 'Boosts Ice-type moves'
  }
};

export const TERRAIN = {
  'Electric': {
    boost: ['Electric'],
    icon: '⚡',
    description: 'Boosts Electric moves for grounded Pokémon'
  },
  'Grassy': {
    boost: ['Grass'],
    icon: '🌱',
    description: 'Boosts Grass moves for grounded Pokémon'
  },
  'Misty': {
    reduce: ['Dragon'],
    icon: '🌸',
    description: 'Weakens Dragon moves for grounded Pokémon'
  },
  'Psychic': {
    boost: ['Psychic'],
    icon: '🔮',
    description: 'Boosts Psychic moves for grounded Pokémon'
  }
}; 